export default __webpack_public_path__ + "src/images/text_start_right-39e92f.png";